import * as React from 'react';

import { cva, type VariantProps } from 'class-variance-authority';

import { Icon } from '../icon';
import { cn } from '@/new/lib/utils';

const alertVariants = cva('relative w-full rounded-lg border px-3.5 py-3 text-sm flex items-start gap-2', {
  variants: {
    variant: {
      default: 'border-gray-200 bg-gray-50 text-gray-700',
      destructive: 'border-red-200 bg-red-50 text-red-700 [&_[data-slot=alert-description]]:text-red-600',
      warning: 'border-amber-200 bg-amber-50 text-amber-700 [&_[data-slot=alert-description]]:text-amber-600',
    },
  },
  defaultVariants: {
    variant: 'default',
  },
});

function Alert({ className, variant, ...props }: React.ComponentProps<'div'> & VariantProps<typeof alertVariants>) {
  return <div data-slot="alert" role="alert" className={cn(alertVariants({ variant }), className)} {...props} />;
}

function AlertTitle({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div className="flex items-center gap-1.5">
      <Icon className="lucide--ban text-xs" />

      <div
        data-slot="alert-title"
        className={cn('mt-px text-xs leading-4 font-semibold tracking-tight', className)}
        {...props}
      />
    </div>
  );
}

function AlertDescription({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div data-slot="alert-description" className={cn('mt-1 text-xs [&_p]:leading-relaxed', className)} {...props} />
  );
}

export { Alert, AlertTitle, AlertDescription };
